import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/refine/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["RefineContext"] */ "/app/refine/src/app/_refine_context.tsx");
